import clsx from "clsx";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MaskedInput from "react-text-mask";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { IEmpresas } from "../../interfaces/IEmpresas";
import { IEsteira } from "../../interfaces/IRelatorioCliente";
import EmpresasService from "../../services/EmpresasService";
import RelatoriosService from "../../services/RelatoriosService";
import { MASCARA_DATA } from "../../utils/Constants";
import Exportacao from "./Exportacao";
import Importacao from "./Importacao";
import RelatorioAndamentoConta from "./RelatorioAndamentoConta";
import RelatorioECD from "./RelatorioECD";
import RelatorioEstorno from "./RelatorioEstorno";
import RelatorioRelatorio from "./RelatorioRelatorio";
import RelatorioResumo from "./RelatorioResumo";
import { pegarEsteiraSelecionada } from "./RelatorioSelecionarCliente";
import RelatorioStatus from "./RelatorioStatus";
import { uniqueId } from "lodash";

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
export enum Tipo {
    Esteira = 'Esteira',
    Erro = 'Erro',
    Aviso = 'Aviso',
    Pendente = 'Pendente',
    Match = 'Match',
    Conciliado = 'Conciliado',
    Recomendacao = 'Recomendacao',
    Relatorio = 'Relatorio',
    Empresa = 'Empresa',
    DataInicial = 'DataInicial',
    DataFinal = 'DataFinal',
    AbaSelecionada = 'AbaSelecionada',
    ContaEmpresa = 'ContaEmpresa',
    ListaContasEmpresa = 'ListaContasEmpresa'
};

export function pegarEmpresaSelecionada(): IEmpresas | undefined {
    const json = localStorage.getItem(`${Tipo.Empresa}`) ?? "";
    const empresa = (json ? JSON.parse(json) : {}) as IEmpresas;

    return empresa;

}

export function dataValida(texto: string): { day: number, month: number, year: number } | undefined {

    let partes: string[] = [];
    let day: number;
    let month: number;
    let year: number;

    //Comentario Teste Rafael
    //formato YYYY/MM/dd
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(texto)) {
        partes = texto.split("/");
        day = parseInt(partes[2], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[0], 10);
    }
    //formato YYYY-MM-dd
    else if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
        partes = texto.split("-");
        day = parseInt(partes[2], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[0], 10);
    }
    //formato dd/MM/YYYY
    else if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
        partes = texto.split("/");
        day = parseInt(partes[0], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[2], 10);
    }
    //formato dd-MM-YYYY
    else if (/^\d{2}-\d{2}-\d{4}$/.test(texto)) {
        partes = texto.split("-");
        day = parseInt(partes[0], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[2], 10);
    }
    else {
        return undefined;
    }

    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
        return undefined;
    }

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
    }

    if (day > 0 && day <= monthLength[month - 1]) {
        return { day, month, year };
    }
}

export const Formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
    //minimumFractionDigits: 0
    //maximumFractionDigits: 0
});

export function limitarTexto(texto: string | undefined, quantidadeCaracteres: number, quantidadeCaracteresManterFinal?: number): string {
    if (texto && texto.length > quantidadeCaracteres) {
        const reticencias = '...';
        const quantidadeCaracteresManterFinalTratado = quantidadeCaracteresManterFinal ?? 0;
        const condicaoPedacoFinal = quantidadeCaracteresManterFinalTratado > 0;
        const quantidadeCaracteresManter = condicaoPedacoFinal ? quantidadeCaracteresManterFinalTratado + reticencias.length : reticencias.length;
        const textoTemp = texto.slice(0, quantidadeCaracteres + quantidadeCaracteresManter).trimEnd();
        const pedacoFinal = texto.slice(texto.length - quantidadeCaracteresManterFinalTratado, texto.length).trimEnd();
        const pedacoFinalTratado = condicaoPedacoFinal ? pedacoFinal : '';
        const textoTempConcatenado = textoTemp + reticencias + pedacoFinalTratado;

        return textoTempConcatenado;
    }

    return texto ?? "";
}

export function Periodo({ botoesVisivel, empresaId, filtroVisivel, acaoBotaoBuscar, dadosExportar, imprimirRelatorioExcel }: { dataInicio: Date | undefined, dataFim: Date | undefined, botoesVisivel?: boolean, empresaId?: number, filtroVisivel?: boolean, acaoBotaoBuscar?: (dataInicial: Date | undefined, dataFinal: Date | undefined) => void, dadosExportar: any, imprimirRelatorioExcel?: () => void }) {
    const { t } = useTranslation();
    const [carregandoEsteira, setCarregandoEsteira] = useState<boolean>(false);
    const [carregandoImprimir, setCarregandoImprimir] = useState<boolean>(false);
    const [esteiraSelecionada, setEsteiraSelecionada] = useState<IEsteira | undefined>();
    const [carregandoExportar, setCarregandoExportar] = useState<boolean>(false);
    const [mostrarOpcoes, setMostrarOpcoes] = useState<boolean>(false);
    const [esteiras, setEsteiras] = useState<any[]>([]);

    useEffect(() => {
        if (empresaId) {
            setCarregandoEsteira(true);
            EmpresasService.obterEsteiras(empresaId).then((resp) => {
                setEsteiras(resp);
                const esteira = pegarEsteiraSelecionada();
                if (esteira) {
                    setEsteiraSelecionada(esteira);
                }

                setCarregandoEsteira(false);
            });
        }
    }, [empresaId]);


    async function exportarTodos() {
        if (empresaId && esteiraSelecionada && esteiraSelecionada.id > 0) {
            setCarregandoExportar(true);
            await RelatoriosService.exportarTodosExcel(empresaId, esteiraSelecionada.periodoInicio, esteiraSelecionada.periodoFim, () => { }, 'Relatório enviado com sucesso! Por gentileza, aguarde alguns minutos, caso não tenha recebido.');
            setCarregandoExportar(false);
        }
    }

    return (
        <div style={{ display: 'flex', marginTop: '10px', alignItems: 'center', width: '100%' }}>
            <div className="form-group" style={{ display: 'flex', alignItems: 'center', visibility: filtroVisivel === undefined || filtroVisivel ? 'visible' : 'hidden' }}>
                {carregandoEsteira && (
                    <div className='col-md-12 mt-2'>
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            {t("Aguarde...")}
                        </span>
                    </div>
                )}
                {!carregandoEsteira && (
                    <>
                        <label style={{ margin: '0 10px' }}>{esteiras.length > 1 ? t('Períodos') : t('Período')} </label>
                        <select className="form-control" value={esteiraSelecionada?.id || 0} onChange={(e) => {
                            const value = parseInt(e.target.value);
                            const esteiraSup = esteiras.find(f => f.id === value);
                            setEsteiraSelecionada(esteiraSup);
                            localStorage.setItem(`${Tipo.Esteira}`, JSON.stringify(esteiraSup));
                            if (acaoBotaoBuscar) {
                                acaoBotaoBuscar(esteiraSup.periodoInicio, esteiraSup.periodoFim);
                            }
                        }}>
                            <option>{t("Selecione um período")}</option>
                            {esteiras.map((item) => (
                                <option value={item.id} key={uniqueId()}>{item.periodoInicioString}-{item.periodoFimString}</option>
                            ))}
                        </select>
                    </>
                )}
            </div>
            <div style={{ position: 'relative', marginLeft: '5px', visibility: botoesVisivel === null || botoesVisivel === undefined || botoesVisivel ? 'visible' : 'hidden' }}>
                <button onClick={() => setMostrarOpcoes(!mostrarOpcoes)} className='btn btn-sm btn-primario' style={{ marginRight: '5px' }}>
                    <i className="icon-lg text-white fas fa-print" />
                    <span style={{ verticalAlign: 'middle' }}> {t("IMPRIMIR")} </span>
                </button>
                {mostrarOpcoes && (
                    <div style={{ width: '100px', display: 'flex', position: 'absolute', top: '54px', right: '81px' }}>
                        <button onClick={() => {
                            console.log(imprimirRelatorioExcel)
                            if (imprimirRelatorioExcel) {
                                imprimirRelatorioExcel()
                            } else {
                                const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                                const fileExtension = ".xlsx";
                                const ws = XLSX.utils.json_to_sheet(dadosExportar);
                                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                                const data = new Blob([excelBuffer], { type: fileType });
                                saveAs(data, `Relatorio-${Date.now()}` + fileExtension);
                            }
                        }} className='btn btn-sm btn-primario'>
                            <i className="icon-lg text-white fas fa-file-medical" />
                            <span style={{ verticalAlign: 'middle' }}> {t("EXPORTAR")} </span>
                        </button>
                        {/* <button style={{ marginLeft: '5px' }} disabled={!(empresaId !== undefined && empresaId >= 0 && esteiraSelecionada > 0) || carregandoImprimir} className='btn btn-sm btn-primario' onClick={async () => imprimir()}>
                            {
                                carregandoImprimir ?
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }} />
                                        Carregando
                                    </span>
                                    :
                                    <>
                                        <i className="icon-lg text-white fas fa-print" />
                                        <span style={{ verticalAlign: 'middle' }}>
                                            IMPRIMIR
                                        </span>
                                    </>
                            }
                        </button> */}
                        <button style={{ marginLeft: '5px' }} disabled={!(empresaId && esteiraSelecionada && esteiraSelecionada.id > 0) || carregandoExportar} className='btn btn-sm btn-primario' onClick={async () => exportarTodos()}>
                            {
                                carregandoExportar ?
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }} />
                                        {t("Carregando...")}
                                    </span>
                                    :
                                    <>
                                        <i className="icon-lg text-white fas fa-print" />
                                        <span style={{ verticalAlign: 'middle' }}>
                                            {t("EXPORTAR TODOS")}
                                        </span>
                                    </>
                            }
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

function Relatorio() {
    const { classes } = useLayout();
    const { id } = useParams<{ id: string }>();
    const [dataInicial, setDataInicial] = useState<Date>();
    const [dataFinal, setDataFinal] = useState<Date>();
    const [abaSelecionada, setAbaSelecionada] = useState<number>(1);
    const [esteiraSelecionada, setEsteiraSelecionada] = useState<IEsteira>();
    const [empresaSelecionada, setEmpresaSelecionada] = useState<IEmpresas>();
    const [dadosExportar, setDadosExportar] = useState<any>();
    const { t } = useTranslation();


    const opcoesFiltros = [
        { id: 1, descricao: t("Status"), habilitado: false },
        { id: 2, descricao: t("Andamento de Contas"), habilitado: false },
        { id: 3, descricao: t("Resumo"), habilitado: true },
        { id: 4, descricao: t("Relatório"), habilitado: true },
        { id: 5, descricao: t("ECDs"), habilitado: false },
        { id: 6, descricao: t("Estornos"), habilitado: false },
        { id: 7, descricao: t("Conciliação Inteligente"), habilitado: false },
        { id: 8, descricao: t("Importações"), habilitado: false },
        { id: 9, descricao: t("Exportações"), habilitado: false }
    ];
    const breadCrumbs: Array<PageLink> = [
        {
            title: 'Clientes',
            path: '/relatorioSelecionarCliente',
            isSeparator: false,
            isActive: false
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: true
        }
    ]

    useEffect(() => {
        function preCarregar() {
            try {
                const titulo = document.querySelectorAll("h1")[0];
                const estilo = titulo.getAttribute('style') + 'font-size: 14px';

                titulo.setAttribute('style', estilo);
            } catch {
                setTimeout(() => {
                    preCarregar();
                }, 50);
            }
        }

        const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
        const dataInicial = JSON.parse(jsonDataInicial) as Date | undefined;
        const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
        const dataFinal = JSON.parse(jsonDataFinal) as Date | undefined;
        const jsonAbaSelecionada = localStorage.getItem(`${Tipo.AbaSelecionada}`) as "";
        const abaSelecionada = JSON.parse(jsonAbaSelecionada) as number ?? 3;

        setDataInicial(dataInicial);
        setDataFinal(dataFinal);
        setAbaSelecionada(abaSelecionada);

        localStorage.setItem(`${Tipo.AbaSelecionada}`, JSON.stringify(null));

        preCarregar();
    }, [])

    useEffect(() => {
        localStorage.setItem(`${Tipo.Empresa}`, JSON.stringify(empresaSelecionada));
    }, [empresaSelecionada])

    useEffect(() => {
        localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
    }, [dataInicial])

    useEffect(() => {
        localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
    }, [dataFinal])

    useEffect(() => {
        localStorage.setItem(`${Tipo.ContaEmpresa}`, JSON.stringify(null));
    }, [abaSelecionada])

    useEffect(() => {
        async function preCarregar() {
            try {
                const empresa = await EmpresasService.obterPorId(parseInt(id));

                setEmpresaSelecionada(empresa);
            } catch (error: any) {
                console.log(error);
            }
        }

        const esteira = pegarEsteiraSelecionada();

        setEsteiraSelecionada(esteira);

        setTimeout(() => {
            preCarregar();
        }, 1000)
    }, [id])

    function BotoesHeaderTabela() {
        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} type="submit" id={`item-${index}`} className={`btn btn-filtro ${x.id === abaSelecionada && x.habilitado && 'ativo'}`} style={{ display: x.habilitado ? 'inline' : 'none' }} disabled={!x.habilitado} onClick={() => x.habilitado && setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    function trocarAba(abaSelecionada: number) {
        switch (abaSelecionada) {
            case 1:
                return <RelatorioStatus empresa={empresaSelecionada} />
            case 2:
                return <RelatorioAndamentoConta empresa={empresaSelecionada} dataInicio={dataInicial} dataFim={dataFinal} />
            case 3:
                return <RelatorioResumo empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} />
            case 4:
                return <RelatorioRelatorio setDadosExportar={setDadosExportar} empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} />
            case 5:
                return <RelatorioECD empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} esteira={esteiraSelecionada} />
            case 6:
                return <RelatorioEstorno empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} />
            case 7:
                return <></>
            case 8:
                return <Importacao empresa={empresaSelecionada} />
            case 9:
                return <Exportacao empresa={empresaSelecionada} />
        }
    };

    function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
        setDataInicial(dataInicial);
        setDataFinal(dataFinal);
    }

    return <>
        <PageTitle pageBack="/relatorioSelecionarCliente" breadcrumbs={breadCrumbs}>{localStorage.getItem(`${Tipo.Relatorio}`)}</PageTitle>
        <div className='toolbar' id='kt_toolbar' style={{ paddingRight: '10px' }}>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ paddingRight: '10px' }}>
                <DefaultTitle />
                <Periodo dadosExportar={dadosExportar} dataInicio={dataInicial} dataFim={dataFinal} botoesVisivel={abaSelecionada === 4} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
            </div>
        </div>

        <BotoesHeaderTabela />
        {
            trocarAba(abaSelecionada)
        }
    </>
};

export default Relatorio;